import dynamic from "next/dynamic";
const RegularTabsComponent = dynamic(()=>import("./regular-tabs-component"));
import RegularTabsConfig from "./regular-tabs-config";
import RegularTabsAdvancedConfig from "./regular-tabs-advanced-config";
export default {
    RegularTabsComponent,
    RegularTabsConfig,
    RegularTabsAdvancedConfig
};
